import dayjs from 'dayjs';

/**
 * คำนวณอัตรา OT อัตโนมัติตามวันที่และวันหยุดนักขัตฤกษ์
 *   - วันอาทิตย์ หรือ วันหยุดนักขัตฤกษ์ (holidayTotal >= 1) → 2.0x
 *   - วันจันทร์–เสาร์ (วันทำงานปกติ)                         → 1.5x
 *
 * @param {Date|dayjs|string} date        วันที่ที่ต้องการตรวจ
 * @param {number}            holidayTotal จำนวนวันหยุดที่ตรงกับวันนั้น (จาก holiday API)
 * @returns {number} 1.5 หรือ 2.0
 */
export default function getOtRateByDate(date, holidayTotal = 0) {
  const dayOfWeek = dayjs(date).day(); // 0 = Sunday, 6 = Saturday
  if (dayOfWeek === 0 || holidayTotal >= 1) return 3.0;
  return 1.5;
}
